import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';


export default function LeadSubmitPage() {
  const { id } = useParams<{ id: string }>();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    company: '',
    message: '',
  });

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <div className="pt-28 sm:pt-32">
        <div className="max-w-2xl mx-auto px-4 md:px-8 py-10">
          <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8 pl-1 sm:pl-2">
            <Link to="/" className="hover:text-foreground-700 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/demands" className="hover:text-foreground-700 transition-colors cursor-pointer">需求大厅</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700">提交合作线索</span>
          </nav>

          <div className="glass-card rounded-2xl p-6 md:p-8">
            <h1 className="font-heading font-bold text-lg text-foreground-950 mb-2">提交合作线索</h1>
            <p className="text-xs text-foreground-500 mb-6">
              针对需求 {id} 提交合作意向，对方将收到通知并查看您的联系方式
            </p>

            <div className="space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">姓名 *</label>
                  <input type="text" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} placeholder="请输入您的姓名" className="w-full px-4 py-3 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-950 placeholder-foreground-400 outline-none focus:border-primary-400/60 transition-all" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">手机号 *</label>
                  <input type="tel" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} placeholder="请输入手机号" className="w-full px-4 py-3 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-950 placeholder-foreground-400 outline-none focus:border-primary-400/60 transition-all" />
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">邮箱</label>
                <input type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} placeholder="请输入邮箱地址" className="w-full px-4 py-3 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-950 placeholder-foreground-400 outline-none focus:border-primary-400/60 transition-all" />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">所属公司/团队</label>
                <input type="text" value={formData.company} onChange={(e) => setFormData({ ...formData, company: e.target.value })} placeholder="请输入公司或团队名称" className="w-full px-4 py-3 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-950 placeholder-foreground-400 outline-none focus:border-primary-400/60 transition-all" />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">合作意向说明 *</label>
                <textarea value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} placeholder="请简要说明您的合作意向和相关经验..." rows={4} maxLength={500} className="w-full px-4 py-3 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-950 placeholder-foreground-400 outline-none focus:border-primary-400/60 transition-all resize-none"></textarea>
                <p className="text-xs text-foreground-400 mt-1 text-right">{formData.message.length}/500</p>
              </div>

              <div className="p-4 rounded-xl bg-gray-50 border border-gray-200/60">
                <p className="text-xs text-foreground-500">
                  <i className="ri-information-line text-secondary-500 mr-1"></i>
                  提交后对方可在「收到的线索」中查看您的联系方式和意向说明。
                </p>
              </div>

              <button className="w-full py-3 rounded-lg bg-primary-500 text-foreground-950 text-sm font-semibold hover:bg-primary-400 transition-all cursor-pointer whitespace-nowrap">
                提交合作线索
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}